import { AppBar, Box, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import CountryPicker from 'components/CountryPicker';
import useUser from 'stores/useCustomer';
import { MainMenuDrawer } from '../MainMenuDrawer';
import { LinkedLogotype } from '../../Logotype/LinkedLogotype';
import { UserActions } from './UserActions';
import MobileMenu from '../components/MobileMenu/MobileMenu';

type MobileHeaderProps = {
    isOpen: boolean;
    toggleDrawer: () => void;
};

export function MobileHeader(props: MobileHeaderProps) {
    const { isOpen, toggleDrawer } = props;
    const isLoggedIn = useUser((state) => state.useLoggedIn());

    const theme = useTheme();
    const isWideScreen = !useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <AppBar position="static">
            <Toolbar sx={{ paddingY: 3, justifyContent: 'space-between' }}>
                <Box sx={{
                    display: 'flex',
                    flexBasis: 0,
                    flexGrow: 1,
                }}
                >
                    <MainMenuDrawer
                        isOpen={isOpen}
                        toggleDrawer={toggleDrawer}
                        hideLanguageSelector
                    >
                        <MobileMenu toggleDrawer={toggleDrawer} />
                    </MainMenuDrawer>
                    {!isWideScreen && !isLoggedIn && <CountryPicker />}
                </Box>
                <Box
                    sx={{
                        flexBasis: 0,
                        flexGrow: 1,
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <LinkedLogotype
                        linkProps={{
                            sx: {
                                display: 'flex',
                                alignItems: 'center',
                                '& img': {
                                    width: { sm: 134, md: 268 },
                                    height: { sm: 19, md: 38 },
                                },
                            },
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexBasis: 0,
                        flexGrow: 1,
                        justifyContent: 'flex-end',
                    }}
                >
                    {isWideScreen && !isLoggedIn && <CountryPicker />}
                    <UserActions />
                </Box>
            </Toolbar>
        </AppBar>
    );
}
